export const isIE = () => {
  let sAgent = window.navigator.userAgent;
  let idx = sAgent.indexOf( 'MSIE' );
  return idx > 0 || navigator.userAgent.match( /Trident\/7\./ );
};